<template>
  <new-modal-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    title="Integration Guide"
    scrollable
    min-width="400px"
    container-class="pa-0"
    card-class="pa-0"
    @close="emit('close')"
  >
    <v-expansion-panels
      class="mt-4"
      mandatory
      accordion
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6 font-weight-medium">
          Website
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Copy the following code and paste it on your website (at the end of the HTML Body section):
          <!-- eslint-disable-next-line vue/max-len vue/first-attribute-linebreak vue/html-closing-bracket-newline vue/max-attributes-per-line -->
          <pre v-highlightjs="widgetScript" class="code-block mt-2"><code class="html code--hljs" /><v-btn dark icon class="code-copy-btn" @click="copyCode(widgetScript)"><v-icon>mdi-content-copy</v-icon></v-btn></pre>
        </v-expansion-panel-content>
        <v-divider />
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6 font-weight-medium">
          Wordpress Plugin
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <span class="text-overline d-block">
            Download and Install
          </span>
          <p>
            In the Add Plugin screen search for "Guestplan Booking Widget" and click the "Install Now" button.
            Alernatively, you can <a
              href="https://wordpress.org/plugins/guestplan-booking-widget/"
              target="_blank"
            >download the plugin</a> and install it manually.
          </p>
          <v-img
            src="/assets/widget/wp_step_1.png"
            contain
          />

          <span class="text-overline d-block pt-4">
            Configure
          </span>
          <p>
            In order to connect to your Guestplan Account, you must enter your API key into the Guestplan Booking Widget Options.
          </p>
          <p>
            Your API Key is:
            <!-- eslint-disable-next-line vue/max-len vue/first-attribute-linebreak vue/html-closing-bracket-newline vue/max-attributes-per-line -->
            <pre v-highlightjs="accessKey" class="code-block mt-2"><code class="html code--hljs" /><v-btn dark icon class="code-copy-btn" @click="copyCode(widgetScript)"><v-icon>mdi-content-copy</v-icon></v-btn></pre>
          </p>
          <v-img
            contain
            src="/assets/widget/wp_step_2.png"
            class="pt-2"
          />
          <p />
        </v-expansion-panel-content>
        <v-divider />
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-h6 font-weight-medium">
          WIX Website Builder
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Copy the following code and follow our <a
            href="https://docs.guestplan.com/#/widget?id=wix-website"
            target="_blank"
          >
            WIX integration guide</a>:
          <!-- eslint-disable-next-line vue/max-len vue/first-attribute-linebreak vue/html-closing-bracket-newline vue/max-attributes-per-line -->
          <pre v-highlightjs="widgetScript" class="code-block mt-2"><code class="html code--hljs" /><v-btn icon dark class="code-copy-btn" @click="copyCode(widgetScript)"><v-icon>mdi-content-copy</v-icon></v-btn></pre>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <template #actions>
      <v-spacer />
      <v-btn
        text
        color="error"
        @click="$emit('close')"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </new-modal-dialog>
</template>
<script lang="ts" setup>
/// eslint-disable no-useless-escape
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import { useToast } from '@/components/helpers/vue2-helpers';

import { computed, ref } from 'vue';

const emit = defineEmits(['close']);
const toast = useToast();

const copyCode = (code: string) => {
  navigator.clipboard.writeText(code);
  toast.success('Code Copied');
};

const props = defineProps<{
  accessKey: string | undefined;
}>();

const widgetScript = computed(() => ` <script>
    (function(g,s,t,p,l,n){
      g["_gstpln"]={};
      (l=s.createElement(t)),(n=s.getElementsByTagName(t)[0]);
      l.async=1;l.src=p;n.parentNode.insertBefore(l,n);
    })(window,document,"script","https://cdn.guestplan.com/widget.js");
  _gstpln.accessKey = "${props.accessKey}";\n`
  // eslint-disable-next-line no-useless-escape
  + '<\/script>');
</script>
<style lang="scss">
  .v-application .code-block code.code--hljs {
    color: #c9d1d9;
    background: #0d1117;
  }

  .code-block {
    border-radius: 4px;
    position: relative;
  }
  .code-block .code-copy-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>
